export default {"src":"/_next/static/media/email.3b5a8845.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};